module.exports = __webpack_public_path__ + "static/media/DSCF9068.4d9f8a11.JPG";